import { useNavigate } from 'react-router-dom'
import { Footer } from '../components/Footer'
import { CardWithImageBackground } from '../components/CardWithImageBackground'

export default function About() {
  const navigate = useNavigate()

  const handleNavigation = (href: string) => {
    navigate(href)
  }

  return (
    <div className="min-h-screen bg-[#d6dbdc] dark:bg-black">
      <div className="container mx-auto px-4 py-8 font-mono">
        <h1 className="text-2xl font-bold mb-4 text-black dark:text-white">About Seto Labs</h1>
        
        <CardWithImageBackground
          className="mb-8"
          title="Innovation Through Technology"
          body="At Seto Labs, we're pioneering the future of software development. Our team combines cutting-edge technology with creative solutions to build tomorrow's digital landscape today."
        />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Our Mission</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            At Seto Labs, we are dedicated to building intelligent software solutions that are both beautiful and fast. Our mission is to empower businesses with cutting-edge technology that drives growth and innovation.
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Our Expertise</h2>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300">
            <li>AI Solutions</li>
            <li>B2B SaaS Development</li>
            <li>Mobile App Development</li>
            <li>UI/UX Design</li>
            <li>Scalable Architecture</li>
          </ul>
        </section>
        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Our Approach</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            We believe in a collaborative approach, working closely with our clients to understand their unique needs
          </p>
        </section>
      </div>
      <Footer onNavigate={handleNavigation} />
    </div>
  )
} 